import styled from 'styled-components/macro';
import { COLORS } from 'styleguide';

const InfoContainer = styled.div`
  display: flex;
  flex-direction: column;
  height: 194px;
  padding-top: 14px;
  border-left: 1px solid ${COLORS.line};
  border-right: 1px solid ${COLORS.line};
  border-bottom: 1px solid ${COLORS.line};
`;

export default InfoContainer;
